import moment from "moment";
import "moment-timezone";

export function filterAsOpen(item, hours) {
    let start, 
        end, 
        format = "HH:mm:ss",
        utcCurrentTime = moment().utc(),
        todaysHoursBlock = getTodaysHours(item),
        lobbyOpen = false,
        driveThruOpen = false;

    if (hours) {
        let dow = getDOW().toLowerCase(),
            todaysHours = hours[dow];
        if (todaysHours) {
            start = createTimeFromHours(todaysHours.open, format, item.timeZone).utc(); 
            end = createTimeFromHours(todaysHours.close, format, item.timeZone).utc();
            
            return (
                utcCurrentTime.isBetween(start, end) ||
                utcCurrentTime.isSame(start) ||
                utcCurrentTime.isSame(end)
            );
        }
    }
    else if (todaysHoursBlock) {
        if (todaysHoursBlock.lobbyHours) {
            let todaysLobbyHours = todaysHoursBlock.lobbyHours;
            if (todaysLobbyHours && todaysLobbyHours.open && todaysLobbyHours.close) {
                start = createTimeFromHours(todaysLobbyHours.open, format, item.timeZone).utc();
                end = createTimeFromHours(todaysLobbyHours.close, format, item.timeZone).utc();
                
                lobbyOpen = (
                    utcCurrentTime.isBetween(start, end) ||
                    utcCurrentTime.isSame(start) ||
                    utcCurrentTime.isSame(end)
                );
            }
        }

        if (todaysHoursBlock.driveThruHours) {
            let todaysDriveThruHours = todaysHoursBlock.driveThruHours;
            if(todaysDriveThruHours && todaysDriveThruHours.open && todaysDriveThruHours.close) {
                start = createTimeFromHours(todaysDriveThruHours.open, format, item.timeZone).utc();
                end = createTimeFromHours(todaysDriveThruHours.close, format, item.timeZone).utc();
                
                driveThruOpen = (
                    utcCurrentTime.isBetween(start, end) ||
                    utcCurrentTime.isSame(start) ||
                    utcCurrentTime.isSame(end)
                );
            }
        }        
    }

    return lobbyOpen || driveThruOpen;
}

export function filterByMeta(list, filters) {
    if(!filters || filters.length == 0) {
        return list;
    }

    return list.filter(item => {
        return  (item.fullService && filters.indexOf("fullService") > -1) ||
                (item.atm && filters.indexOf("atm") > -1) ||
                (item.driveThru && filters.indexOf("driveThru") > -1) ||
                (item.instantIssueDebitCard && filters.indexOf("instantIssueDebitCard") > -1) ||
                (item.lending && filters.indexOf("lending") > -1) ||
                (item.wealth && filters.indexOf("wealth") > -1) ||
                (item.quickDeposit && filters.indexOf("quickDeposit") > -1) ||
                (item.safeDepositBoxes && filters.indexOf("safeDepositBoxes") > -1);
    });
}

export function filterHours(list, hours) {
    let openSaturdays = hours && hours.indexOf("saturdays") > -1,
        open = hours && hours.indexOf("now") > -1;

    if (open) {
        list = list.filter(item => {
            return filterAsOpen(item);
        });
    }

    if (openSaturdays) {
        list = list.filter(item => {
            let itemLobbySaturdayHrs = item.lobbyHours["saturday"],
                itemDriveThruSaturdayHrs = item.driveThruHours["saturday"];
            
            return (itemLobbySaturdayHrs != undefined && itemLobbySaturdayHrs.open != undefined && itemLobbySaturdayHrs.close != undefined) ||
            (itemDriveThruSaturdayHrs != undefined && itemDriveThruSaturdayHrs.open != undefined && itemDriveThruSaturdayHrs.close != undefined);
        });
    }

    return list;
}

export function getTodaysHours(item) {
    let dow = getDOW().toLowerCase(),
        itemLobbyHrs = item.lobbyHours[dow],
        itemDriveThruHours = item.driveThruHours[dow],
        payload = {
            dow: dow,
            lobbyHours: itemLobbyHrs,
            driveThruHours: itemDriveThruHours
        };
    return payload;
}

export function getDOW() {
    let utcCurrentTime = moment().utc(),
        activeTimeZone = moment.tz.guess(true),
        timeInActiveTimeZone = moment.tz(utcCurrentTime, activeTimeZone),
        dow = timeInActiveTimeZone.format("dddd");
                
    return dow;
}


//we are only passing in the hour, we need to build the moment based on the current timezone's date (assumes input format is HH:mm)
//if the user's current time is the next day in UTC, time was being created for that day implicitly. need to specify date of the current time in the given timeZone.
export function createTimeFromHours(hours, hoursFormat, timeZone) {
    let dateFormat = "MM/DD/YYYY";
    let currentTime = moment.tz(timeZone);
    let date = currentTime.format(dateFormat);
    let time = moment.tz(date + ' ' + hours, dateFormat + ' ' + hoursFormat, timeZone);
    
    return time;
}
